import Axios, { AxiosRequestConfig } from 'axios';

// Determine base URL at runtime based on environment
const getBaseURL = (): string => {
  // Local development
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:3001';
  }

  // Production and staging use same origin as frontend
  return window.location.origin;
};

export const AXIOS_INSTANCE = Axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
});

export const customInstance = <T>(
  config: AxiosRequestConfig,
): Promise<T> => {
  return AXIOS_INSTANCE({
    ...config,
  }).then(({ data }) => data);
};

export default customInstance;
